import { Object3D, Vector2Tuple } from 'three';

import { DecorationShallowNode } from '@spazious/dollhouse-shallow-graph';

import { Collider } from '../core/index.js';
import { ColliderNode, DecorationNode, FNodeTypesEnum } from '../types/index.js';

import { BaseNodeImpl } from './BaseNode.js';

export class DecorationNodeImpl extends BaseNodeImpl implements DecorationNode {
  type: FNodeTypesEnum.Decoration = FNodeTypesEnum.Decoration;
  shallow: DecorationShallowNode | null = null;
  id: number = 0;
  name: string = '';
  position: Vector2Tuple = [0, 0];
  rotation: number = 0;
  url: string = '';
  decorationType: string = '';
  object: Object3D | null = null;
  collider: Collider | null = null;
  collisions: ColliderNode[] = [];
  visible: boolean = true;
  get outline2D() {
    return this.object?.outline2D ?? null;
  }
  computeOutline2D() {
    this.object?.computeOutline2D();
  }
  toJSON(recursive?: boolean) {
    return {
      ...super.toJSON(recursive),
      id: this.id,
      name: this.name,
      url: this.url,
      position: this.position,
      rotation: this.rotation,
      decorationType: this.decorationType,
      shallow: this.shallow,
      collisions: this.collisions.map((node) => node.selector),
    };
  }
}
